import faker from 'faker';
import React from 'react';
import PropTypes from 'prop-types';
import { noCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';
import { set, sub, formatDistanceToNow } from 'date-fns';
import { Icon } from '@iconify/react';
import bellFill from '@iconify/icons-eva/bell-fill';
import clockFill from '@iconify/icons-eva/clock-fill';
import doneAllFill from '@iconify/icons-eva/done-all-fill';
import awardOutline from '@iconify/icons-eva/award-outline';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import plusFill from '@iconify/icons-eva/plus-fill';
import hardDriveFilled from '@iconify/icons-eva/hard-drive-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import safetyCertificate from '@iconify/icons-ant-design/safety-certificate';
import emailFilled from '@iconify/icons-eva/email-fill';
import globeOutline from '@iconify/icons-eva/globe-outline';
// material
import { alpha, useTheme } from '@mui/material/styles';
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Tooltip,
  Divider,
  IconButton,
  Typography,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon
} from '@mui/material';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
// utils
import { mockImgAvatar } from '../../utils/mockImages';
// components
import Scrollbar from '../../components/Scrollbar';
import MenuPopover from '../../components/MenuPopover';
import * as notifikasiService from '../../services/notifikasi';

// ----------------------------------------------------------------------

const NOTIFICATIONS = [
  // {
  //   id: faker.datatype.uuid(),
  //   title: 'Your order is placed',
  //   description: 'waiting for shipping',
  //   avatar: null,
  //   type: 'order_placed',
  //   createdAt: set(new Date(), { hours: 10, minutes: 30 }),
  //   isUnRead: true
  // },
  // {
  //   id: faker.datatype.uuid(),
  //   title: faker.name.findName(),
  //   description: 'answered to your comment on the Minimal',
  //   avatar: mockImgAvatar(2),
  //   type: 'friend_interactive',
  //   createdAt: sub(new Date(), { hours: 3, minutes: 30 }),
  //   isUnRead: true
  // },
  // {
  //   id: faker.datatype.uuid(),
  //   title: 'You have new message',
  //   description: '5 unread messages',
  //   avatar: null,
  //   type: 'chat_message',
  //   createdAt: sub(new Date(), { days: 1, hours: 3, minutes: 30 }),
  //   isUnRead: false
  // },
  // {
  //   id: faker.datatype.uuid(),
  //   title: 'You have new mail',
  //   description: 'sent from Guido Padberg',
  //   avatar: null,
  //   type: 'mail',
  //   createdAt: sub(new Date(), { days: 2, hours: 3, minutes: 30 }),
  //   isUnRead: false
  // },
  // {
  //   id: faker.datatype.uuid(),
  //   title: 'Delivery processing',
  //   description: 'Your order is being shipped',
  //   avatar: null,
  //   type: 'order_shipped',
  //   createdAt: sub(new Date(), { days: 3, hours: 3, minutes: 30 }),
  //   isUnRead: false
  // }
];

function renderContent(notification) {
  const title = (
    <Typography variant="subtitle2">
      {notification?.attributes?.payload?.title}
      <Typography component="span" variant="body2" sx={{ color: 'text.secondary' }}>
        &nbsp; {notification?.attributes?.payload?.description}
      </Typography>
    </Typography>
  );

  let icon = '';
  if (notification?.attributes?.payload?.title.toLowerCase() === 'feedback') icon = fileTextFill;
  if (notification?.attributes?.payload?.title.toLowerCase() === 'permohonan hosting')
    icon = hardDriveFilled;
  if (notification?.attributes?.payload?.title.toLowerCase() === 'kategori sistem elektronik')
    icon = menu2Fill;
  if (notification?.attributes?.payload?.title.toLowerCase() === 'permohonan tte')
    icon = safetyCertificate;
  if (notification?.attributes?.payload?.title.toLowerCase() === 'permohonan subdomain')
    icon = globeOutline;

  if (notification?.attributes?.payload?.title.toLowerCase() === 'permohonan rekomendasi')
    icon = awardOutline;

  return {
    // avatar: <img src='' alt={notification?.attributes?.payload?.description} />,
    icon,
    title
  };
}

NotificationItem.propTypes = {
  notification: PropTypes.object.isRequired
};

function NotificationItem({ notification }) {
  const { icon, title } = renderContent(notification);
  const theme = useTheme();

  return (
    <ListItemButton
      to="#"
      disableGutters
      component={RouterLink}
      sx={{
        py: 1.5,
        px: 2.5,
        mt: '1px',
        ...(notification.isUnRead && {
          bgcolor: 'action.selected'
        })
      }}
    >
      {/* <ListItemAvatar>
        <Avatar sx={{ bgcolor: theme.palette.primary.main }}>{avatar}</Avatar>
      </ListItemAvatar> */}
      <ListItemIcon>
        <Icon width={24} height={24} color={theme.palette.grey[600]} icon={icon} />
      </ListItemIcon>
      <ListItemText
        primary={title}
        secondary={
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              display: 'flex',
              alignItems: 'center',
              color: 'text.disabled'
            }}
          >
            <Box component={Icon} icon={clockFill} sx={{ mr: 0.5, width: 16, height: 16 }} />
            {formatDistanceToNow(new Date(notification?.attributes?.payload?.timestamp))}
          </Typography>
        }
      />
    </ListItemButton>
  );
}

NotificationsPopover.propTypes = {
  user: PropTypes.object.isRequired
};

export default function NotificationsPopover({ user }) {
  const anchorRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const [notifications, setNotifications] = React.useState([]);
  const totalUnRead = notifications.filter((item) => item.isUnRead === true).length;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMarkAllAsRead = () => {
    setNotifications(
      notifications.map((notification) => ({
        ...notification,
        isUnRead: false
      }))
    );
  };

  const getNotifications = async () => {
    try {
      if (!user) return;
      const body = {
        id_user: user?.attributes?.id,
        role: user?.attributes?.role
      };

      if (!body.role) return;

      const result = await notifikasiService.getAll(body);
      setNotifications(result.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getNotifications();
  }, [user]);

  return (
    <>
      <IconButton
        ref={anchorRef}
        size="large"
        color={open ? 'primary' : 'default'}
        onClick={handleOpen}
        sx={{
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <Badge badgeContent={totalUnRead} color="error">
          <Icon icon={bellFill} width={20} height={20} />
        </Badge>
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 360 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">Notifikasi</Typography>
            {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {totalUnRead} notifikasi belum dibaca
            </Typography> */}
          </Box>

          {totalUnRead > 0 && (
            <Tooltip title=" Mark all as read">
              <IconButton color="primary" onClick={handleMarkAllAsRead}>
                <Icon icon={doneAllFill} width={20} height={20} />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <Divider />

        <Scrollbar sx={{ height: notifications.length > 0 ? 400 : 60 }}>
          <List
            disablePadding
            // subheader={
            //   <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
            //     Belum dibaca
            //   </ListSubheader>
            // }
          >
            {notifications.map((notification) => (
              <NotificationItem key={notification.id} notification={notification} />
            ))}

            {_.isEmpty(notifications) && (
              <Typography variant="body2" sx={{ textAlign: 'center', padding: 2 }}>
                Belum ada notifikasi
              </Typography>
            )}
          </List>

          {/* <List
            disablePadding
            subheader={
              <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                Sudah dibaca
              </ListSubheader>
            }
          >
            {notifications.slice(2, 5).map((notification) => (
              <NotificationItem key={notification.id} notification={notification} />
            ))}
          </List> */}
        </Scrollbar>

        <Divider />

        {/* <Box sx={{ p: 1 }}>
          <Button fullWidth disableRipple component={RouterLink} to="#">
            Lihat Semua
          </Button>
        </Box> */}
      </MenuPopover>
    </>
  );
}
